// $( window ).on("load", function() {
//   $(".loader-container").fadeOut();
// });


$( window ).on("load", function() {
 $('.pro_slider').css('opacity', '1');
  $('.pro_slider').css('visibility', 'visible');
});

$(document).ready(function(){


  $('.banner--slider').slick({
  dots: true,
  infinite: true,
    arrows: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
  autoplaySpeed: 3000,
});
  
  
//   $('.column_wrapper').slick({
//     arrows: true,
//     dots: false,
//     slidesToShow: 3,
//     draggable: false,
//     infinite: false,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 750,
//         settings: {
//           slidesToShow: 1,
//         }
//       }
//     ]
//   });
  
  
  $('.recognized_wrapper ul').slick({
    centerMode: true,
    arrows: false,
    dots: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          centerMode: true,
          slidesToShow: 1
        }
      }
    ]
  });
  $('.collection_homepage .grid--view-items').slick({
    arrows: false,
    dots: false,
    slidesToShow: 3,
    responsive: [
      {
            breakpoint: 9999,
            settings: "unslick"
        },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          infinite: true,
          centerMode: true,
          centerPadding: '30px',
          adaptiveHeight: true,
          draggable: true,
          autoplay: true,
          autoplaySpeed: 5000,
        }
      }
    ]
  });
  $('.custom_posts .grid--blog').slick({
    arrows: false,
    dots: false,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          infinite: true,
          centerMode: true,
          centerPadding: '30px',
          adaptiveHeight: true,
          draggable: true,
          autoplay: true,
          autoplaySpeed: 5000,
        }
      }
    ]
  });


  $('.UPS_icons ul').slick({
    arrows: false,
    dots: false,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          draggable: true,
          autoplay: true,
          autoplaySpeed: 5000,
          dots: true,
        }
      }
    ]
  });





  //   $('.main_slider').slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     arrows: true,
  //     dots: false,
  //     infinite: false,
  //     adaptiveHeight: true,
  //     asNavFor: '.thumb_slider',
  //   });
  //   $('.thumb_slider').slick({
  //     slidesToShow: 5,
  //     slidesToScroll: 1,
  //     asNavFor: '.main_slider',
  //     dots: false,
  //     focusOnSelect: true,
  //     arrows: false,
  //     infinite: false,
  //   });


















  $('.site-footer__item .h4').click(function(){
    $(this).toggleClass('active');
  });
  $('.new_search_btn').click(function(){
    $('body').addClass('js-drawer-open js-drawer-open-top');
  });
  $('.btn--link.search-bar__close.js-drawer-close').click(function(){
    $('body').removeClass('js-drawer-open js-drawer-open-top');
  });

  $('.view_more').click(function(){
    $('.gallery_wrapper').addClass('show_more');
  });




  //   zoom's code


  //   $('.zoom_icon').click(function(){
  //     $('.main_slider').addClass('active');
  //     $('.close_zoom').addClass('show');
  //     $('body').addClass('overflow_hidden');
  //   });

  //   $('.close_zoom').click(function(){
  //     $(this).removeClass('show');
  //     $('.main_slider').removeClass('active');
  //     $('body').removeClass('overflow_hidden');
  //   });


  //  Zoom's code

  $('.fil_lab_mob .filters-toolbar__label.select-label').click(function(){
    $('.col-fltrs-nav').toggleClass('active');

  });

  $('.apnd-curr').click(function(){
    $('.mob-srt-by').toggleClass('active');
  });

  $('.fil_lab_mob .filters-toolbar__label.select-label').click(function(){
    $('.mob-srt-by').removeClass('active');
  });

  $('.apnd-curr').click(function(){
    $('.col-fltrs-nav').removeClass('active');
  });



  $('.see_more_pop').click(function(){
    $('.accessories_popup').css('display', 'flex');
  });

  $('.popup_close1').click(function(){
    $('.accessories_popup').css('display', 'none');
  });
  $('.popup_overly1').click(function(){
    $('.accessories_popup').css('display', 'none');
  });



});



$(function() {
  $('.acc__title').click(function(j) {

    var dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.acc').find('.acc__panel').not(dropDown).slideUp();

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.acc').find('.acc__title.active').removeClass('active');
      $(this).addClass('active');
    }

    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});



document.documentElement.classList.add('js');

/// ----------------------------

jQuery(document).ready(function(){
  const $rootSingle = $('.main_slider');
  const $rootNav = $('.thumb_slider');

  $rootSingle.slick({
    slide: '.cSlider__item',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    adaptiveHeight: true,
    infinite: false,
    useTransform: true,
    speed: 400,
    cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
  });

  $rootNav.on('init', function(event, slick) {
    $(this).find('.slick-slide.slick-current').addClass('is-active');
  })
  .slick({
    slide: '.cSlider__item',
    slidesToShow: 5,
    slidesToScroll: 3,
    dots: false,
    focusOnSelect: false,
    infinite: false,

  });

  $rootSingle.on('afterChange', function(event, slick, currentSlide) {
    $rootNav.slick('slickGoTo', currentSlide);
    $rootNav.find('.slick-slide.is-active').removeClass('is-active');
    $rootNav.find('.slick-slide[data-slick-index="' + currentSlide + '"]').addClass('is-active');
  });

  $rootNav.on('click', '.slick-slide', function(event) {
    event.preventDefault();
    var goToSingleSlide = $(this).data('slick-index');

    $rootSingle.slick('slickGoTo', goToSingleSlide);
  });
});


jQuery(document).ready(function(){
  // This button will increment the value
  $('.qtyplus').click(function(e){
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name='+fieldName+']').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $('input[name='+fieldName+']').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $('input[name='+fieldName+']').val(0);
    }
  });
  // This button will decrement the value till 0
  $(".qtyminus").click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name='+fieldName+']').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 1 ) {
      // Decrement one
      $('input[name='+fieldName+']').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $('input[name='+fieldName+']').val(1);
    }
  });

  $('#quart').on('input', function(e) {
    e.preventDefault();

    var currentVal = parseInt($("#quart").val());

    if (!isNaN(currentVal) && currentVal == 0 ) {
      $(".error-msg-zero").html('Quantity not be "0"').fadeIn();
      $('#quart').val(1);

    } 

    setTimeout(function(){  $(".error-msg-zero").fadeOut();}, 4000);


  });

});

$("#product").submit(function(e){

  var input = $('#quart').val();
  if(input == ''){
    $(".error-msg-zero").html('Quantity not be "Blank"').fadeIn();
    $('#quart').val(1);
  } 

  e.preventDefault();
});


// zoom initializer

// $(function() {
//   $('.zoom-image').each(function(){
//     var originalImagePath = $(this).find('img').data('original-image');
//     $(this).zoom({
//       url: originalImagePath,
//       magnify: 1
//     });
//   });
// }); 

// zoom initializer




$( document ).ready(function() {

  // if sort by is featured
  if (window.location.href.indexOf("manual") > -1) {
    // alert('featured');
    $('.apnd-curr').text("Featured");

  }

  // if sort by is best-selling
  else if (window.location.href.indexOf("best-selling") > -1) {
    //alert('Best selling');
    $('.apnd-curr').text("Best selling");
  }


  // if sort by is Alphabetically, A-Z
  else if (window.location.href.indexOf("title-ascending") > -1) {
    //alert('Alphabetically A-Z');
    $('.apnd-curr').text("Alphabetically, A-Z");
  }


  // if sort by is Alphabetically, Z-A
  else if (window.location.href.indexOf("title-descending") > -1) {
    //alert('Alphabetically Z-A');
    $('.apnd-curr').text("Alphabetically, Z-A");
  }

  // if sort by is Price, low to high
  else if (window.location.href.indexOf("price-ascending") > -1) {
    //alert('Price, Low to High');
    $('.apnd-curr').text("Price, low to high");
  }


  // if sort by is Price, high to low
  else if (window.location.href.indexOf("price-descending") > -1) {
    // alert('Price, High to Low');
    $('.apnd-curr').text("Price, High to low");
  }


  // if sort by is Date, old to new
  else if (window.location.href.indexOf("created-ascending") > -1) {
    //alert('Date, old to new');
    $('.apnd-curr').text("Date, Old to new");
  }


  // if sort by is Date, new to old
  else if (window.location.href.indexOf("created-descending") > -1) {
    //alert('Date, new to old');
    $('.apnd-curr').text("Date, New to old");
  }

  else{
    //alert('featured');
    $('.apnd-curr').text("Featured");

  }


});

$( document ).ready(function() {
  if (window.location.href.indexOf("all") > -1) {

    $( "ul.col-fltrs-nav li:nth-child(2)" ).addClass( "active" );

  }

  else if (window.location.href.indexOf("accessories") > -1) {

    $( "ul.col-fltrs-nav li:first-child" ).addClass( "active" );

  }

  else if (window.location.href.indexOf("spare-parts") > -1) {

    $( "ul.col-fltrs-nav li:nth-child(5)" ).addClass( "active" );

  }

  else if (window.location.href.indexOf("merch") > -1) {

    $( "ul.col-fltrs-nav li:nth-child(3)" ).addClass( "active" );

  }

  else if (window.location.href.indexOf("other") > -1) {

    $( "ul.col-fltrs-nav li:nth-child(4)" ).addClass( "active" );

  }

});

// $( document ).ready(function() {
//   $('li.gm-item:first-child > .gm-target span.gm-text').click(function() {
//     window.location.href = '/collections/electric-bikes';
//     return false;
//   });
// });
// $('button selector').click(function(){
//    window.location.href='the_link_to_go_to.html';
// })


// $( window ).on("load", function() {
//   $('.slider_related').slick({
//     arrows: false,
//     dots: false,
//     slidesToShow: 3,
//     adaptiveHeight: true,
//     responsive: [
//       {
//         breakpoint: 750,
//         settings: {
//           slidesToShow: 1,
//           infinite: true,
//           centerMode: true,
//           centerPadding: '30px',
//           adaptiveHeight: true,
//           draggable: true,
//           autoplay: true,
//           autoplaySpeed: 5000,
//         }
//       }
//     ]
//   });
// }); 

$( window ).on("load", function() {
  var input = document.getElementById('ContactFooter-email');

  input.value = '';
}); 


$( document ).ready(function() {
  if (window.location.href.indexOf("/tagged/news") > -1) {

    $( "ul.col-fltrs-nav.chi li:nth-child(4)" ).addClass( "active" );

  }

  else if (window.location.href.indexOf("/tagged/knowledge") > -1) {

    $( "ul.col-fltrs-nav.chi li:nth-child(3)" ).addClass( "active" );

  }


  else if (window.location.href.indexOf("/tagged/snapcyclers") > -1) {

    $( "ul.col-fltrs-nav.chi li:nth-child(5)" ).addClass( "active" );

  }

  else if (window.location.href.indexOf("/tagged/tips") > -1) {

    $( "ul.col-fltrs-nav.chi li:nth-child(6)" ).addClass( "active" );

  }


  else if (window.location.href.indexOf("/tagged/guide-books") > -1) {

    $( "ul.col-fltrs-nav.chi li:nth-child(2)" ).addClass( "active" );

  }


  else {

    $( "ul.col-fltrs-nav.chi li:first-child" ).addClass( "active" );

  }


});





$(document).ready(function(){

  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })

});



$(document).ready(function(){

  (function () {
    getVideos();
  })();


  function getVideos() {
    var v = document.getElementsByClassName("youtube-player");
    for (var n = 0; n < v.length; n++) {
      var p = document.createElement("div");
      var id = v[n].getAttribute("data-id");

      var placeholder = v[n].hasAttribute("data-thumbnail")
      ? v[n].getAttribute("data-thumbnail")
      : "";

      if (placeholder.length) p.innerHTML = createCustomThumbail(placeholder);
      else p.innerHTML = createThumbail(id);

      v[n].appendChild(p);
      p.addEventListener("click", function () {
        var parent = this.parentNode;
        createIframe(parent, parent.getAttribute("data-id"));
      });
    }
  }


  function createCustomThumbail(url) {
    return (
      '<img class="youtube-thumbnail" src="' +
      url +
      '" alt="Youtube Preview" /><div class="youtube-play-btn"></div>'
    );
  }


  function createThumbail(id) {
    return (
      '<img class="youtube-thumbnail" src="//i.ytimg.com/vi_webp/' +
      id +
      '/maxresdefault.webp" alt="Youtube Preview"><div class="youtube-play-btn"></div>'
    );
  }


  function createIframe(v, id) {
    var iframe = document.createElement("iframe");
    console.log(v);
    iframe.setAttribute(
      "src",
      "//www.youtube.com/embed/" +
      id +
      "?autoplay=1&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0"
    );
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("class", "youtube-iframe");
    v.firstChild.replaceWith(iframe);
  }

  $("#video-modal").on("hidden.bs.modal", function (e) {
    $(this).find("iframe").remove();
  });

  $("#video-modal").on("show.bs.modal", function (e) {
    getVideos();
  });


});



$(document).ready(function() {
  $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content2")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa-plus")
        .addClass("fa-plus");
    } else {
      $(".set > a i")
        .removeClass("fa-plus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-plus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content2").slideUp(200);
      $(this)
        .siblings(".content2")
        .slideDown(200);
    }
  });
  
  $(".icons_wrap_1 li:last-child .anchor a").attr("onclick", "zE(function() {zE.activate();});");
  
});


// window.onscroll = function() {myFunction()};
// var header = document.querySelector("#shopify-section-header .site-header");
// var sticky = header.offsetTop;
// function myFunction() {
//   if (window.pageYOffset > sticky) {
//     header.classList.add("sticky");
//   } else {
//     header.classList.remove("sticky");
//   }
// }